import { Navigate, useParams } from "react-router-dom";
import { LoaderComponent } from "@/shared/components/ui";
import { ROUTER_PATHS } from "@/shared";
import SaveSolicitudTecnicoPymes from "@/erp/mantenimiento-operacion/solicitud_tecnico/shared/componente/save_solicitud_tecnico_pymes/SaveSolicitudTecnicoPymes";
import { useFetchGetPreagendamientoPymesById } from "@/shared/actions/erp/operaciones/preagendamiento/preagendamiento_pymes.actions";

export default function EditSolicitudTecnicoNocPage() {

  const { id } = useParams();

  const {
    data,
    isLoading,
  } = useFetchGetPreagendamientoPymesById(id!)

  if (isLoading)
    return <LoaderComponent />

  if (!data)
    return <Navigate to={ROUTER_PATHS.noc.solicitudTecnicoNocNav} />

  return <SaveSolicitudTecnicoPymes
    preagendamiento={data?.data}
    title="Solicitud Técnico NOC"
    router_path={ROUTER_PATHS.noc.solicitudTecnicoNocNav}
    es_corporativo={true}
  />

}